import UserStore from 'stores/UserStore';
import allUserGroups from 'enum/userGroups';

import { triggerConfetti } from './confetti';
import { triggerFireworks } from './fireworks';


const FIREWORKS_THRESHOLD = 250;
const showTippingAnimation = (amount) => {
  const { user } = UserStore;

  if (user?.activeCampaign?.activeCampaignName !== allUserGroups.BIRTHDAY_TOKEN_OFFER_10_PERCENT) {
    return;
  }

  if (amount >= FIREWORKS_THRESHOLD) {
    triggerFireworks();
  } else {
    triggerConfetti(amount);
  }
};

export { showTippingAnimation };
